import { render, staticRenderFns } from "./OsCreateTargetProfileForm.vue?vue&type=template&id=55579baa&scoped=true"
import script from "./OsCreateTargetProfileForm.vue?vue&type=script&lang=ts"
export * from "./OsCreateTargetProfileForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55579baa",
  null
  
)

export default component.exports